import React from "react";
import {observer, inject} from "mobx-react";
import {observable} from 'mobx';
import EditProduct from "./EditProduct";
import EditProductSimple from "./EditProductSimple";
import ErrorBoundry from "@components/ErrorBoundry/ErrorBoundry";
import getBoxPadUrl from "@utils/getBoxPadUrl"
import {QuantityEdit} from "../Products/QuantityEdit";

@inject("store")
@observer

export default class OrderList extends React.Component {
    @observable
    EditProduct = [];

    @observable
    currentOrder = null;

    constructor(props) {
        super(props);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.toggleProductlineEdit = this.toggleProductLineEdit.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
        this.getSplitOrderInfo = this.getSplitOrderInfo.bind(this);
        this.goToPage = this.goToPage.bind(this);
    }


    //componentWillMount() {
    //    //console.log("componentWillMount: OrderList");
    //    this.EditProduct = [];
    //}

    componentWillUpdate() {
        //		console.log("componentWillUpdate");
    }

    componentWillReceiveProps(next, current) {

    }

    openProductDialog(e, sku) {
        e.preventDefault();
        const navigationStore = this.props.store.navigation;
        navigationStore.openProductDialog(sku);
    }

    goToPage(e, url) {
        console.log("goToPage", url);
        e.preventDefault();
        if (!url) {
            return;
        }
        const {navigation} = this.props.store;
        const newHistoryObject = navigation.mainRouter
            ? {
                pathname: url,
                search: navigation.mainRouter.location.search,
                hash: null,
                state: null,
            } : null;

        navigation.mainRouter.replace(newHistoryObject);
    }


    toggleProductLineEdit(e, sku) {
        e.preventDefault();
        e.stopPropagation();
        const index = this.EditProduct.indexOf(sku);
        if (index > -1) {
            this.EditProduct = [...this.EditProduct.slice(0, index), ...this.EditProduct.slice(index + 1)];
        } else {
            this.EditProduct.push(sku);
        }
    }

    removeProduct(e, sku, name) {
        e.stopPropagation();
        e.preventDefault();
        const order = this.props.order;

        if (!order) return;
        if (confirm("Are you sure that you want to remove:\n" + name + "\n" + sku)) {
            order.removeProduct(sku).then(res => {
                    //success
                },
                err => {
                    alert(err.message);
                });
        }
    }

    getSplitOrderInfo(product) {
        let info = [];
        let index = 1;
        let orderStore = this.props.store.order;
        if (orderStore.activeOrder.SplitOrders) {
            product.OrderLines.forEach((o) => {
                if (o.Properties) {
                    o.Properties.forEach((property) => {
                        if (property.Key.indexOf("_splitorder_") > -1 && !info.find((value) => {
                            return value.valueNumber === property.Value
                        })) {
                            let infoText = "";
                            let splitOrderInfo = orderStore.activeOrder.SplitOrders.find((order) => {
                                return order.Key === property.Value;
                            });
                            if (splitOrderInfo) {
                                infoText = splitOrderInfo.Reason;
                            }

                            info.push({
                                index: index++,
                                className: "material-icons warning",
                                value: property.Value + ". " + infoText,
                                valueNumber: property.Value
                            });
                        }
                    });
                }
                return;
            });
        }

        return info;
    }

    stockExceeded(productList) {
        for (var orderLine of productList.OrderLines) {
            const prop = orderLine.Properties.find(x => x.Key === "_StockExceeded");
            if (prop && prop.Value === "1") {
                return "exceeded";
            }
        }
        return "";
    }


    render() {

        const orderStore = this.props.store.order;
        const navigation = this.props.store.navigation;

        const order = orderStore.activeOrder;
        const showDetails = this.props.showDetails || false;

        const sortedOrderLines = order.ProductList.flatMap(pl => pl.OrderLines.flatMap(ol => ol)).sort((a, b) => {
            return a.Sku.localeCompare(b.Sku)
        })

        const isReadonly = this.props.readOnly;

        if (!order) {
            return (<div>Laddar...</div>);
        }

        return (

            <div className="purchaseorder-content scroll-content">


                <div className={"purchaseorder-content-inner"}>
                    {sortedOrderLines.map(orderLine => {
                        const brand = orderLine.PropertyValueByKey("_brand");
                        const stockStatus = orderLine.PropertyValueByKey("StockStatus");
                        let stockInfo = "";
                        switch (stockStatus) {
                            case "PreBook":
                                stockInfo = "*Förbokad*";
                                break;
                        }

                        return (
                            <div key={orderLine.OrderLineId} className={"d-flex mb-3"}>
                                <div className={"image"}>
                                    <a href={orderLine.ProductUrl} onClick={(e) => {
                                        e.preventDefault();
                                        navigation.navigateToSiteUrl(null, orderLine.ProductUrl, null, null, navigation.getSearchParameters());
                                        //navigation.navigateToSiteUrl(null, orderLine.ProductUrl)
                                    }}>
                                        <img alt="" className=""
                                             src={orderLine.PrimaryImageUrl
                                                 ? getBoxPadUrl(orderLine.PrimaryImageUrl,
                                                     80,
                                                     80,
                                                     navigation.ImageFormat,
                                                     "ffffff").url
                                                 : "/umbraco/Ucommerce/images/ui/image-not-found.png"
                                             }
                                             width={40}/>
                                    </a>
                                </div>
                                <div className={"name"}>
                                    {isReadonly
                                        ? <React.Fragment>
                                            <div className="brand">{brand}</div>
                                            <div className={"title-container"}>
                                                <span className="title">{orderLine.Name}</span>
                                            </div>
                                            {stockInfo}<br/>
                                        </React.Fragment>
                                        : <a href={orderLine.ProductUrl} onClick={(e) => {
                                            e.preventDefault();
                                            navigation.navigateToSiteUrl(null, orderLine.ProductUrl, null, null, navigation.getSearchParameters());
                                        }}
                                        >
                                            <div className="brand">{brand}</div>
                                            <div className={"title-container"}>
                                                <span className="title">{orderLine.Name}</span>
                                            </div>
                                            {stockInfo}<br/>
                                        </a>
                                    }
                                    {/*<span className="hidden-lg-up float-right mr-3">&nbsp;{orderLine.PriceExFormatted} {order.Currency}</span>*/}
                                </div>
                                <div className={"price"}>{orderLine.PriceExFormatted} {order.Currency}</div>
                                <div className={"quantity"}>

                                    {isReadonly
                                        ? orderLine.Quantity
                                        : <QuantityEdit
                                            key={orderLine.Sku + "_" + orderLine.VariantSku}
                                            orderStore={this.props.store.order}
                                            sku={orderLine.Sku}
                                            variantSku={orderLine.VariantSku}
                                            //quantity={this.state.quantity}
                                            increments={orderLine.PropertyValueByKey("PackSize") || 1}
                                        />}
                                </div>

                            </div>
                        );
                    })
                    }

                </div>
            </div>
        );
    }
}